export const CamaMesaEBanhoIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.33341 10H16.6667C17.5872 10 18.3334 10.7462 18.3334 11.6667V15C18.3334 15.4602 17.9603 15.8333 17.5001 15.8333H2.50008C2.03984 15.8333 1.66675 15.4602 1.66675 15V11.6667C1.66675 10.7462 2.41294 10 3.33341 10Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33325 10V5.83337C3.33325 4.45266 4.45254 3.33337 5.83325 3.33337H14.1666C15.5473 3.33337 16.6666 4.45266 16.6666 5.83337V10"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="5.83325"
        y="6.66663"
        width="8.33333"
        height="3.33333"
        rx="1.5"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.4999 15.8334V17.5"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.49992 15.8334V17.5"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
